import React, { useState, useEffect, ChangeEvent } from 'react';
import {
  convertHalfToFull,
  convertJaSmallToLarge,
} from '../../../common/utils/stringUtil';
import { POPULAR_BANKS_VIEW } from './bankModalView';
import BankClient from '../../../common/models/banks/bankClient';
import type { Bank } from '../../../common/models/banks/bank';
import type { BankBranch } from '../../../common/models/banks/bankBranch';
import { handleAxiosError } from '../../../common/helpers/axiosHelper';
import { simpleFlashMessage } from '../../../common/utils/flashMessage';

interface Props {
  bank: Bank;
  onTransition: (view: number) => void;
  onChangeBranch: (branch: BankBranch) => void;
  onCancel: () => void;
}

export default function SelectBranchView({
  bank,
  onTransition,
  onChangeBranch,
  onCancel,
}: Props) {
  const [branches, setBranches] = useState<BankBranch[]>([]);
  const [appBranches, setAppBranches] = useState<BankBranch[]>([]);
  const [keyword, setKeyword] = useState<string>('');

  useEffect(() => {
    const bankClient = new BankClient();
    bankClient
      .fetchBranches(bank.id)
      .then(response => {
        setBranches(response.data);
      })
      .catch(error => {
        handleAxiosError(error, simpleFlashMessage);
      });
  }, [bank.id]);

  const onChangeKeyword = (event: ChangeEvent<HTMLInputElement>) => {
    const keyword = event.target.value;

    if (keyword !== '') {
      setAppBranches(
        branches.filter(b => {
          return (
            b.name.includes(keyword) ||
            b.name.includes(convertHalfToFull(keyword)) ||
            b.kana.includes(convertJaSmallToLarge(keyword)) ||
            b.hiragana.includes(convertJaSmallToLarge(keyword))
          );
        }),
      );
    } else {
      setAppBranches([]);
    }

    setKeyword(keyword);
  };

  return (
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header text-center">
          <h5 className="modal-title w-100">支店を選択</h5>
          <button type="button" className="close" onClick={onCancel}>
            <span>&times;</span>
          </button>
        </div>
        <div className="modal-body p-40">
          <form>
            <div className="form-group">
              <label htmlFor="bank_branch">支店名で検索</label>
              <input
                id="bank_branch"
                type="text"
                className="form-control"
                placeholder="支店名を入力"
                value={keyword}
                onChange={onChangeKeyword}
                onKeyDown={event => {
                  if (event.key === 'Enter') {
                    event.preventDefault();
                  }
                }}
              />
            </div>
          </form>
          <div className="row bank-branch-select">
            {appBranches.map(b => (
              <div className="col-md-4 mb-20" key={b.id}>
                <button
                  type="button"
                  className="btn btn-lg btn-block btn-flat btn-outline-primary"
                  onClick={() => onChangeBranch(b)}
                >
                  {b.name}
                </button>
              </div>
            ))}
          </div>
          <button
            type="button"
            className="btn btn-lg back-btn btn-outline-primary"
            onClick={() => onTransition(POPULAR_BANKS_VIEW)}
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
}
